import React, { useEffect, useState } from "react";
import { Modal, Button, List, Tag, Space, Typography, message } from "antd";
import dayjs from "dayjs";
import SaleResultModal, {
  SALE_RESULT,
  SALE_RESULT_META,
} from "./SaleResultModal";

const { Text } = Typography;

const fullName = (g) =>
  `${g?.SNAM || ""}${g?.NAME1 || ""} ${g?.NAME2 || ""}`.trim();

const RecordSaleResultModal = ({ open, onClose, group, onSuccess }) => {
  // ✅ ผลรายนัด { [round]: { resultType, price, reason } }
  const [results, setResults] = useState({});
  const [editing, setEditing] = useState({
    open: false,
    round: null,
    date: null,
  });

  // ✅ โหลดผลเดิม (ถ้าเคยบันทึกไว้) ทุกครั้งที่เปิด
  useEffect(() => {
    if (open) setResults(group?.saleResults ? { ...group.saleResults } : {});
  }, [open, group]);

  // เฉพาะนัดที่มีวันนัดแล้ว
  const schedule = (group?.saleSchedule || []).filter((s) => s.date);

  const openEdit = (round, date) => setEditing({ open: true, round, date });
  const closeEdit = () => setEditing((p) => ({ ...p, open: false }));
  const confirmEdit = (result) =>
    setResults((prev) => ({ ...prev, [editing.round]: result }));

  const handleSave = () => {
    if (Object.keys(results).length === 0) {
      message.warning("กรุณาบันทึกผลอย่างน้อย 1 นัด");
      return;
    }
    onSuccess?.({ group, saleResults: results });
    message.success("บันทึกผลการขายสำเร็จ");
    onClose(false);
  };

  return (
    <Modal
      title="บันทึกผลการขาย"
      open={open}
      onCancel={() => onClose(false)}
      width={620}
      destroyOnHidden
      footer={[
        <Button key="close" onClick={() => onClose(false)}>
          ปิด
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          บันทึก
        </Button>,
      ]}
    >
      <Space wrap size={8} style={{ marginBottom: 12 }}>
        <Tag color="purple">Lot {group?.lotNo || "-"}</Tag>
        <Tag>{group?.contno}</Tag>
        <Text type="secondary">{fullName(group)}</Text>
      </Space>

      {schedule.length === 0 ? (
        <Text type="secondary">ยังไม่มีวันนัดขาย</Text>
      ) : (
        <List
          size="small"
          bordered
          dataSource={schedule}
          rowKey={(s) => s.round}
          renderItem={(s) => {
            const r = results[s.round];
            const meta = r ? SALE_RESULT_META[r.resultType] : null;
            const isSold = r?.resultType === SALE_RESULT.SOLD;
            return (
              <List.Item
                actions={[
                  <Button
                    key="rec"
                    type={r ? "default" : "primary"}
                    size="small"
                    onClick={() => openEdit(s.round, s.date)}
                  >
                    {r ? "แก้ไขผล" : "บันทึกผล"}
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  title={`นัดที่ ${s.round}`}
                  description={
                    <Space size={8} wrap>
                      <Text type="secondary">
                        {dayjs(s.date).add(543, "year").format("D MMM YYYY")}
                      </Text>
                      {meta && (
                        <Tag color={meta.color}>
                          {meta.label}
                          {isSold &&
                            `: ${Number(r.price).toLocaleString("th-TH")} บาท`}
                        </Tag>
                      )}
                      {meta && !isSold && r.reason && (
                        <Text type="secondary">{r.reason}</Text>
                      )}
                    </Space>
                  }
                />
              </List.Item>
            );
          }}
        />
      )}

      {/* Modal บันทึกผลรายนัด (reuse) */}
      <SaleResultModal
        open={editing.open}
        round={editing.round}
        date={editing.date}
        initialResult={results[editing.round]}
        onClose={closeEdit}
        onConfirm={confirmEdit}
      />
    </Modal>
  );
};

export default RecordSaleResultModal;
